module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hlbZC"))).then(() => parcelRequire('hEqeo'));